import { useDispatch, useSelector } from 'react-redux';
import MLButtonToggle from '../../../../MLButtonToggle/MLButtonToggle';
import { get } from 'lodash/fp';
import { sendFeedbackEvent } from '../../../../../actions/sendAnalytics';
import { isgTogglePointOrGrade } from '../../../../../actions/analyticsEvents';
import { useSearchParams } from '../../hooks/useSearchParams';
import s from './Body.module.css';

export const PointOrGradeToggleButton = () => {
  const courseId = useSelector(get('gradebook.courseId'));
  const dispatch = useDispatch();
  const [params, setSearchParams] = useSearchParams();
  const showPercent = params.get('showPercent');
  const isShowPercent = showPercent !== 'false';

  const updateShowPercent = (showPercent) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      showPercent: showPercent ? 'true' : 'false',
    }));
    dispatch(
      sendFeedbackEvent(
        isgTogglePointOrGrade(courseId, showPercent ? '%' : 'pts'),
      ),
    );
  };

  return (
    <MLButtonToggle
      classNameContainer={s.pointOrGrade}
      btnText="%"
      btnTextSecondary="pts"
      btnType={isShowPercent ? 'primary' : 'secondary'}
      onClick={() => updateShowPercent(true)}
      btnTypeSecondary={!isShowPercent ? 'primary' : 'secondary'}
      onClickSecondary={() => updateShowPercent(false)}
      testIdPrimary="individual-student-gb-percent-toggle-button"
      testIdSecondary="individual-student-gb-points-toggle-button"
    />
  );
};
